import React, {useEffect, useState} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import StepsLoader from "../steps-loader";
import InputField from "../../base-components/base-input";
import getStep from '../../../helpers/getStep';

const Income = ({ _step_service, step_ID, step_URL, next_step, setDataToContext, getDataFromContext }) => {
    const data = getDataFromContext(step_ID)
    
    const [inputData, setInputData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [nextTick, setNextTick] = useState(false)



    const getInputValue = (name, value) => {
        if (value !== "") {
               setInputData({
            ...inputData,
            [name] : value
               })
        }
    }

    const action = () => {
        _step_service({step_ID, setIsLoading, next_step})
    }

    useEffect(() => {
        if (Object.keys(inputData).length > 0) {
            setDataToContext(step_ID, step_URL, step_ID, inputData[step_ID])
            setNextTick(true)
        }
    }, [inputData])

        useEffect(() => {
        if (Object.keys(inputData).length > 0) {
            action()
        }
    }, [nextTick])

        const [savedData, setSavedData] = useState({})
    useEffect(() => {
        const asyncfunc = async () => {
            if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                        pageID: "onboarding",
                        stepSeq: "2",
                        stepName: "financial info:monthly net income",
                        flowType: "sales",
                        flowName: "onboarding",
                        productName: "onboarding",
                        trackMethod: "flow"
                    }
                );
            }
            const serverData = await getStep(['income'])
            setSavedData({income: Number(serverData.income)})
        }
        asyncfunc()
     }, [])

    const optionsList = [
        {value:1, label: t("financial_infos.financial_info_monthly_net_income.less_1000") },
        { value: 2, label: t("financial_infos.financial_info_monthly_net_income.1000_2500") },
        {value:3, label:t("financial_infos.financial_info_monthly_net_income.2500_4000")},
        { value: 4, label: t("financial_infos.financial_info_monthly_net_income.4000_6000") },
        {value:5, label:t("financial_infos.financial_info_monthly_net_income.more_6000")}
    ]

    return (
        <>
            <StepsLoader loading={isLoading}>
                <BaseParagraph>
                    <h3>{ t("financial_infos.financial_info_monthly_net_income.title")}</h3>
                    <p>{ t("financial_infos.financial_info_monthly_net_income.text")}
                    </p>
                </BaseParagraph>

                <InputField type={"select"} name={"income"}
                            options={optionsList}
                    getInputValue={getInputValue}
                    defaultSelect={savedData && savedData[step_ID]}


                />
            </StepsLoader>
        </>
    )
}

Income.propTypes = {
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
    error: PropTypes.array,
    _step_service: PropTypes.func,
}




export default Income